import React from 'react';
import PageHeader from '@/components/common/PageHeader';
import { useAuth } from '../../hooks/useAuth';
import { useLearnerProfile } from '../../hooks/learner/useLearnerProfile';
import { useImageUrl } from '../../services/uploads';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();
  const { data: profile } = useLearnerProfile();
  const [avatarUrl] = useImageUrl(user?.avatar_url ?? null);

  return (
    <div className="space-y-6 max-w-lg">
      <PageHeader title="Profile" root={{ label: 'Home', to: '/learn/dashboard' }} />
      <div className="p-6 rounded-xl border border-border bg-surface-primary space-y-4">
        <div className="flex items-center gap-4">
          {avatarUrl ? (
            <img src={avatarUrl} alt="" className="w-16 h-16 rounded-full object-cover" />
          ) : (
            <div className="w-16 h-16 rounded-full bg-primary-200 dark:bg-primary-800 flex items-center justify-center text-primary-700 dark:text-primary-200 text-2xl font-bold">
              {user?.first_name?.[0]}
              {user?.last_name?.[0]}
            </div>
          )}
          <div>
            <p className="font-semibold text-text-primary text-lg">
              {user?.full_name ?? `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim()}
            </p>
            <p className="text-sm text-text-secondary">{user?.email}</p>
          </div>
        </div>
        {profile?.department_name && (
          <p className="text-sm text-text-secondary">Department: {profile.department_name}</p>
        )}
        {profile?.location_name && (
          <p className="text-sm text-text-secondary">Location: {profile.location_name}</p>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
